// import axios from 'axios'
// import axios from 'axios'
import axios from "axios";
import { getToken } from "../unit/index";
import { message, Spin } from "antd";

import qs from "qs";
import ReactDOM from "react-dom";
import { Component } from "react";
const service = axios.create({
  //默认地址
  baseURL: "/api", // process.env.REACT_APP_TEST_URL,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 * 10,
});
message.config({
  maxCount: 1,
});

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    //只针对get方式进行序列化
    if (config.method === "get") {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }

    // 需要token的接口默认添加上token
    if (!config.headers.withOutToken) {
      // 不在header中去掉withOutToken会引发CORS错误
      delete config.headers.withOutToken;
      config.headers["authorization"] = `Bearer ${getToken()}`;
      // config.headers['token'] = `Bearer ${getToken()}`;
    } else {
      delete config.headers.withOutToken;
    }

    return config;
  },
  function (error) {
    console.log(error);
    // 对请求错误做些什么
    // 判断当前请求是否设置了不显示Loading

    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    if (!response) {
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    console.log(error);
    if (error && error.response) {
      if (error.response.status === 401) {
        message.error("当前用户不能查看或操作！");
        window.location.href = "/";
      } else if (error.response.status === 422) {
        message.info("请求格式错误，请检查！");
      } else if (error.response.status === 500) {
        message.error({
          content: "服务器内部错误",
        });
      } else if (error.response.status === 550) {
        const reader = new FileReader();
        reader.onload = function () {
          const responseData = JSON.parse(reader.result);
          message.error(responseData.message);
        };
        reader.readAsText(error.response.data);
        const file = new FileReader();
        file.readAsText(error.response.data, "utf-8");
        file.onload = function () {
          const obj = JSON.parse(file.result);
          message.error(obj.message);
          console.log(obj.message);
          if (obj.code === 550) {
            showCustomErrorAlert(obj.message);
          }
          return obj;
        };
      } else if (
        error.response.status > 500 &&
        error.response.status !== 550 &&
        error.response.status < 600
      ) {
        message.error({
          content: `服务器错误，请稍后重试，若仍有问题请联系客服！`,
        });
      }
    } else if (error && error.request) {
      message.error({
        content: `网络错误，请检查网络连接后重试，若仍有问题请联系客服！`,
      });
    } else {
      message.error({
        content: `发生错误，请联系客服!`,
      });
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
function showCustomErrorAlert(message) {
  const alertDiv = document.createElement("div");
  const icon = document.createElement("span");
  icon.style.padding = "3px";
  icon.style.borderRadius = "60px";
  icon.style.backgroundColor = "#FE545F";
  icon.style.color = "#fff";
  icon.style.fontSize = "12px";
  icon.style.marginRight = "8px";
  icon.textContent = "X";
  alertDiv.appendChild(icon);
  const messageText = document.createElement("span");
  messageText.textContent = message;
  alertDiv.appendChild(messageText);
  alertDiv.style.position = "fixed";
  alertDiv.style.top = "10%";
  alertDiv.style.left = "50%";
  alertDiv.style.transform = "translate(-50%, -50%)";
  alertDiv.style.padding = "8px";
  alertDiv.style.fontSize = "14px";
  alertDiv.style.color = "#000";
  alertDiv.style.borderRadius = "8px";
  alertDiv.style.boxShadow = "0px 0px 10px rgba(0, 0, 0, 0.5)";

  document.body.appendChild(alertDiv);

  setTimeout(() => {
    document.body.removeChild(alertDiv);
  }, 2000);
}
Component.prototype.$axios = service;
export default service;
